import {Condition, Event} from '@/model/types';

export const clearEntries = <TArrays extends string[]>(arrays: TArrays, conditions: Condition[] = []) => {
  const event = {
    action: {
      type: 'clearEntries',
      array: arrays,
    },
  } as const;

  if (conditions.length) {
    return {...event, conditions} satisfies Event;
  }

  return event satisfies Event;
};
